var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApolloScraper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 4.44048,
    y1: 0.88619,
    x2: 81.05694,
    y2: 83.47983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9ffae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.309,
    stopColor: "#f9ff5d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48883,
    stopColor: "#f9ff2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f9a42d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.17747,88.61091c-18.78499,2.12302-37.56996,2.12302-56.35494,0-5.49081-.62055-9.8129-4.94264-10.43345-10.43345-2.12301-18.78497-2.12301-37.56995,0-56.35493.62055-5.49081,4.94265-9.8129,10.43346-10.43345,18.78498-2.12301,37.56995-2.12301,56.35494,0,5.49081.62055,9.8129,4.94264,10.43346,10.43345,2.12301,18.78497,2.12301,37.56995,0,56.35492-.62055,5.49081-4.94265,9.8129-10.43345,10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43.78802,50.24738c.88293-.27344,1.56372.77301.93567,1.43604l-11.81848,12.4859c1.55664,1.78687,3.38666,3.31561,5.422,4.52948l8.63214-15.9339c1.20447-2.22595-.4483-4.9032-3.02563-4.90198l-16.25195.00598c-.06915.70178-.10553,1.4118-.10553,2.13043-.00037,1.71356.20416,3.42096.60919,5.08594l15.6026-4.83789Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M56.01099,52.21326l16.29968-.00732c.07544-.72583.11316-1.46136.11316-2.20526,0-1.73248-.20605-3.41656-.5954-5.03149l-15.67297,4.85962c-.88171.27344-1.56372-.77301-.93451-1.43732v.00012l11.88129-12.55255c-1.56152-1.79395-3.3985-3.32812-5.44196-4.54504l-8.67487,16.01727c-1.20575,2.22479.44702,4.9032,3.02557,4.90198Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51.65784,55.16266l12.81195,11.56293c1.82611-1.50732,3.4024-3.29413,4.65833-5.29395l-16.36377-8.45142c-2.27838-1.17706-5.02142.43671-5.02008,2.95422l.00757,15.85284c.73859.07135,1.48956.10889,2.24811.10889,1.73071.00098,3.45605-.19342,5.14313-.57947l-4.95721-15.24066c-.28003-.86133.7926-1.52667,1.47198-.91339Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52.19922,44.14178l-.00757-15.9339c-.72089-.06781-1.45184-.10406-2.19171-.10406-1.75659-.00116-3.50751.19934-5.21838.59772l4.97595,15.29858c.28003.86133-.7926,1.52673-1.47198.91345l-12.82953-11.57867c-1.81873,1.51453-3.38733,3.3075-4.63446,5.31201l16.3576,8.44904c2.2782,1.17706,5.02142-.43671,5.02008-2.95416Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApolloScraper);
export default __webpack_public_path__ + "static/media/apollo-scraper.3d762328c13a648acd9a161d32e5c51b.svg";
export { ForwardRef as ReactComponent };